import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import './AppFooter.css';

const AppFooter: React.FC = () => {
  const { t } = useTranslation('layout');
  return (
    <footer className="app-footer" role="contentinfo">
      <nav className="app-footer-nav" aria-label={t('footer.navLabel')}>
        <ul>
          <li>
            <Link to="/legal/privacy">{t('footer.privacy')}</Link>
          </li>
          <li>
            <Link to="/legal/terms">{t('footer.terms')}</Link>
          </li>
          <li>
            <Link to="/legal/accessibility">{t('footer.accessibility')}</Link>
          </li>
          <li>
            <Link to="/legal/dpa">{t('footer.dpa')}</Link>
          </li>
          <li>
            <Link to="/legal/subprocessors">{t('footer.subprocessors')}</Link>
          </li>
          <li>
            <Link to="/legal/security">{t('footer.security')}</Link>
          </li>
          <li>
            <Link to="/legal">{t('footer.allPolicies')}</Link>
          </li>
        </ul>
      </nav>
      <p className="app-footer-copy">{t('footer.copyright', { year: new Date().getFullYear() })}</p>
    </footer>
  );
};

export default AppFooter;
